import styled from '@emotion/styled';
import { Modal } from 'antd';
import { Button } from 'components';
import { theme } from 'configs/styled';
import { useQueryParams } from 'hooks/useQueryParams';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const ModalStyle = styled(Modal)`
  .ant-modal-content {
    font-family: ${theme.fonts.NotoSansTh}, ${theme.fonts.NotoSands};
  }
`;

interface IConfirmReturnModal {
  isShow: boolean;
}

const ConfirmReturnModal: React.FC<IConfirmReturnModal> = props => {
  const { isShow: when } = props;
  const { search, pushUrl } = useQueryParams();
  const history = useHistory();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState('');

  useEffect(() => {
    if (when) {
      history.block(prompt => {
        setCurrentPath(prompt.pathname);
        setShowPrompt(true);
        return '';
      });
    } else {
      history.block(() => {});
    }

    return () => {
      history.block(() => {});
    };
  }, [history, when]);

  const handleOK = useCallback(async () => {
    history.block(() => {});
    pushUrl(currentPath, search);
  }, [currentPath, history]);

  const handleCancel = () => {
    setShowPrompt(false);
  };

  return (
    <ModalStyle
      title="คุณต้องการที่จะออกจากหน้านี้หรือไม่?"
      visible={showPrompt}
      onOk={handleOK}
      onCancel={handleCancel}
      closable={true}
      footer={[
        <Button key="back" onClick={handleCancel}>
          ยกเลิก
        </Button>,
        <Button key="submit" type="primary" onClick={handleOK}>
          ยืนยัน
        </Button>,
      ]}
    >
      ข้อมูลของคุณยังไม่ได้ทำการบันทึกลงฐานข้อมูลของระบบ
      คุณต้องการที่จะออกจากหน้านี้หรือไม่ ?
    </ModalStyle>
  );
};

export default ConfirmReturnModal;
